import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Other Physical Assets Edit View
 * Now uses the unified AssetFormWrapper component
 */
const OtherPhysicalAssetsView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="other-physical-assets"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default OtherPhysicalAssetsView;
